import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FabricanteController from '../../../../controllers/FabricanteController';
import * as path from '../../../../routes/RoutesNames';
import { toast } from 'react-toastify';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Button } from '../../../../shared/components/button/Button';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu'
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  fab_id: number;
  fab_descricao: string;
}

export default function Fabricante() {
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const tableColumns: Column[] = [
    { id: 'Id', label: 'Id', minWidth: 0, align:'center' },
    { id: 'Descricao', label: 'Descrição', minWidth: 0, align:'left' },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];
  const fields = [
    { name: 'FabricanteId', type: 'text', label: 'Código' },
    { name: 'Descricao', type: 'text', label: 'Descrição' },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) },
  ];
  const [tableRows, setTableRows] = useState<Row[]>([]);
  const initialValues = {
    FabricanteId: null,
    Descricao: '',
  };

  const handleNavigation = async (): Promise<void> => {
    navigate(path.FabricanteCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(path.FabricanteAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(path.FabricanteAtualizar.replace(':id', item.fab_id.toString()));
    }
  };

  const handleSubmit = async (values: any) => {
    const DataRows: any = [];
    const Response = await FabricanteController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          Id: item.fab_id,
          Descricao: item.fab_descricao,
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: "Editar" },
                { onClick: () => handleDeleteItem(item.fab_id), menu: "Excluir", confirmar: `Excluir o fabricante "${item.fab_descricao ?? ''}"? Esta ação não pode ser desfeita.` },
              ]}
            />
          ),
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      toast('Não há registros cadastrados.', {
        type: 'warning',
      });
    } else {
      toast(Response?.Data, {
        type: 'error',
      });
    }
  };

  const handleDeleteItem = async (fab_id: number) => {
    const request: any = { UsuId: userId, FabricanteId: fab_id };
    const response = await FabricanteController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Fabricante excluído com sucesso!', {
        type: 'success',
      });
      handleSubmit(initialValues)
    } else {
      toast('Erro ao excluir o fabricante!', {
        type: 'error',
      });
    }
  };

  useEffect(() => {
    handleSubmit(initialValues)
  }, []);

  return (
    <Box>
      <HeaderComponent text={'FABRICANTES'}
        ButtonRight={
          <Button
            className={''}
            variant='success'
            onClick={handleNavigation}
            iconStart={<Icon.Add />}
            title={'Incluir'}
          />
        }
      />
      <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} gap='gap-3' />
      <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
        handleEditItem(row, true, row.Id);
      }} />
    </Box>
  );
}
